import { NgStyle, UpperCasePipe } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MatOption,
  MatSelect,
  MatSelectTrigger
} from '@angular/material/select';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import {
  LanguageCode,
  LanguageStore
} from '../../../shared/services/language.store';
import { HeaderDialogComponent } from './header-dialog/header-dialog.component';
import { AuthStateService } from '../../../shared/services/state/auth-state.service';

@Component({
  selector: 'app-header',
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatSelect,
    MatOption,
    MatFabButton,
    TranslatePipe,
    MatSelectTrigger,
    UpperCasePipe,
    NgStyle
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  readonly #languageStore: LanguageStore = inject(LanguageStore);
  readonly authStateService: AuthStateService = inject(AuthStateService);
  readonly #dialog = inject(MatDialog);

  public $language: Signal<LanguageCode> = computed(() =>
    this.#languageStore.currentLanguageCode()
  );

  public $code: Signal<string | null> =
    this.authStateService.selectProducerCode();

  public languageChange(code: LanguageCode): void {
    this.#languageStore.setCurrentLanguageCode(code);
  }

  public openDialog(): void {
    this.#dialog.open(HeaderDialogComponent, {
      width: '280px',
      height: '220px'
    });
  }
}
